import {Component, forwardRef} from '@angular/core';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import {NumberInputComponent} from '../number-input.component';

@Component({
    selector: 'kiwi-mark-input',
    templateUrl: './input-with-unit.component.html',
    styleUrls: ['./input-with-unit.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => MarkInputComponent),
            multi: true
        }
    ],
    standalone: false
})
export class MarkInputComponent extends NumberInputComponent {
    constructor() {
        super();
        this.unit = '/ 100';
        this.step = 0.01;
    }
}
